"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LEAD_REGISTERED = exports.FILER_REGISTERED = exports.SCREENER_DISQUALIFIED = exports.SCREENER_QUALIFIED = exports.SCREENER_STARTED = void 0;
var SCREENER_STARTED = 'screenerStarted';
exports.SCREENER_STARTED = SCREENER_STARTED;
var SCREENER_QUALIFIED = 'screenerQualified';
exports.SCREENER_QUALIFIED = SCREENER_QUALIFIED;
var SCREENER_DISQUALIFIED = 'screenerDisqualified';
exports.SCREENER_DISQUALIFIED = SCREENER_DISQUALIFIED;
var FILER_REGISTERED = 'filerRegistered';
exports.FILER_REGISTERED = FILER_REGISTERED;
var LEAD_REGISTERED = 'leadRegistered';
exports.LEAD_REGISTERED = LEAD_REGISTERED;